import { IRootScopeService } from 'angular';
import { IAddFormService } from './addFormService';

const layoutRemoveEvent = 'layoutRemove';

export interface IPlanService {
  onSegmentsChange(): void;
  registerPhotoIdAsPlan(id: number): void;
}

export const PlanService = ['addFormService', '$rootScope',
  (addFormService: IAddFormService, $rootScope: IRootScopeService): IPlanService => {
    const photoIdsFromPlanField: Array<number> = [];

    const CATEGORIES_WITH_LAYOUT = ['newBuildingFlatSale', 'flatSale', 'flatRent', 'dailyFlatRent'];

    const checkAdTypeWithPlanField = () => {
      const { ad } = addFormService;

      const category = ad && ad.category;

      return CATEGORIES_WITH_LAYOUT.includes(category as string);
    };

    const clearUploadedPlans = () => {
      const { ad } = addFormService;

      photoIdsFromPlanField.forEach(id => {
        $rootScope.$emit(layoutRemoveEvent, { id });
      });

      // Удаляем поле вручную, так как компонент планировки (plan-upload)
      // не обработает remove event из-за destroy ивента, связанного со сменой
      // типа объекта и удалением компонента из дерева отрисовки
       // istanbul ignore next
      if (ad) { // Проверка есть до вызова функции, но мы юзаем addFormService напрямую и проверяем дополнительно
        ad.layoutPhoto = null;
      }

      photoIdsFromPlanField.length = 0;
    };

    /**
     * Удаляет фото планировок, если тип объекта не содержит поля Планировка
     */
    const onSegmentsChange = () => {
      const isAdTypeWithPlanField = checkAdTypeWithPlanField();

      if (!isAdTypeWithPlanField) {
        const { ad } = addFormService;

        const isCleaningNeeded = photoIdsFromPlanField.length !== 0 || Boolean(ad && ad.layoutPhoto);

        if (isCleaningNeeded) {
          clearUploadedPlans();
        }
      }
    };

    /**
     * Запоминает id фото планировок для удаления при переключении типа объекта
     * не несовместимый с планировками
     */
    const registerPhotoIdAsPlan = (id: number) => {
      photoIdsFromPlanField.push(id);
    };

    const service = {
      onSegmentsChange,
      registerPhotoIdAsPlan,
    };

    return service;
  },
];
